interface Stat {
  id: number;
  name: string;
  value: string;
}

const stats: Stat[] = [
  { id: 1, name: "Active Users", value: "100,000+" },
  { id: 2, name: "Authentication Requests", value: "1 Billion+" },
  { id: 3, name: "Uptime Guarantee", value: "99.99%" },
  { id: 4, name: "Integrations Available", value: "50+" },
];
export const StatsSection = () => {
  return (
    <div className="mx-auto mt-32 max-w-7xl px-6 sm:mt-56 lg:px-8">
      <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-xl">
        <h2 className="text-base/8 font-semibold text-indigo-400">
          Proven Success
        </h2>
        <p className="mt-2 text-4xl font-semibold tracking-tight text-pretty text-white sm:text-5xl">
          Trusted by Thousands of client Worldwide
        </p>
        <p className="mt-6 text-lg/8 text-gray-300">
          Join the many users who trust us to power their projects with seamless
          integration and security.
        </p>
      </div>
      <dl className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-10 text-white sm:mt-20 sm:grid-cols-2 sm:gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-4">
        {stats.map((stat) => (
          <div
            key={stat.id}
            className="flex flex-col gap-y-3 border-l border-white/10 pl-6"
          >
            <dt className="text-sm/6">{stat.name}</dt>
            <dd className="order-first text-3xl font-semibold tracking-tight">
              {stat.value}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
};
